import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import Api from "./Api";
import { orcamentoAutoOnlineApiConfig } from "./config";
import { FiltroOrcamentoSolicitadoDTO } from "./orcamento-auto/FiltroOrcamentoSolicitadoDTO";
import OrcamentoOnlineModel from "@/models/orcamento-auto-online/OrcamentoOnlineModel";
import { VeiculoModel } from "@/models/orcamento-auto-online/VeiculoModel";
import { VeiculoDTO } from "./orcamento-auto/OrcamentoSolicitadoDTO";
import { DadosComplementaresVeiculoDTO } from "./orcamento-auto/DadosComplementaresVeiculoDTO";
import { AprovacaoSolicitacaoOrcamentoDTO } from './orcamento-auto/AprovacaoSolicitacaoOrcamentoDTO';
import { FaixaDePrecoDTO} from "@/models/orcamento-auto-online/FaixaPrecoConcerto";
import { ClienteFrotaDTO} from "@/models/orcamento-auto-online/ClienteFrotaModel";

class OrcamentoAutoApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  obterOrcamentos(filtro: FiltroOrcamentoSolicitadoDTO): Promise<any> {
    return this.get(`/orcamentos`, {
      params: filtro,
    })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter orçamentos.");
      });
  }

  obterOficinas(cidade: string, estado: string): Promise<any> {
    // Esse serviço em específico está demorando mais que o normal.
    // Setando a informação apenas para essa chamada
    return this.get(`/oficinas?cidade=${cidade}&estado=${estado}`, {
      timeout: 15000
    })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter oficinas.");
      });
  }

  obterOficinasComDistancia(cidade: string, estado: string, idCliente: number, idOrcamento: number): Promise<any> {
    // Esse serviço em específico está demorando mais que o normal.
    // Setando a informação apenas para essa chamada

    let payload = {
      cidade: cidade,
      estado: estado,
      idCliente: idCliente,
      idOrcamento: idOrcamento
    };

    return this.post(`/oficinas/busca-distancia`, payload, {
      timeout: 60000
    })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter oficinas.");
      });
  }

  obterOcamentoPorId(id: number): Promise<OrcamentoOnlineModel> {
    return this.get(`/orcamentos/${id}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter orçamento.");
      });
  }

  obterFotoVeiculo(idOrcamento: number, nomeArquivo: string): Promise<any> {
    return this.get(`/orcamentos/${idOrcamento}/veiculo/foto/${nomeArquivo}`, {
      responseType: "blob",
    })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter foto do veículo.");
      });
  }

  recusar(idOrcamento: number, motivoRecusa?: string, realizarEstorno?: boolean): Promise<string> {
    return this.put<any>(`/orcamentos/${idOrcamento}/recusar`, {
      motivo: motivoRecusa,
      estorno: realizarEstorno,
    })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao recusar");
      });
  }

  atualizarInformacoesCadastrais(idOrcamento: number,detalhesOrcamento: any): Promise<string> {
    return this.put<any>(`/orcamentos/${idOrcamento}/atualizar-informacoes-cadastrais`, detalhesOrcamento)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao atualizar");
      });
  }

  aprovar(
    idOrcamento: number,
    aprovacaoSolicitacaoOrcamentoDTO: AprovacaoSolicitacaoOrcamentoDTO
  ): Promise<string> {
    return this.put<any>(`/orcamentos/${idOrcamento}/aprovar`, aprovacaoSolicitacaoOrcamentoDTO)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao aprovar");
      });
  }

  obterPDForcamento(idOrcamento: number): Promise<any> {
    return this.get(`/orcamentos/${idOrcamento}/download`, {
      responseType: "blob",
      headers: {
        Accept: "application/octet-stream",
      },
    })
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter orçamento.");
      });
  }

  obterFaixaPrecoConcerto(): Promise<FaixaDePrecoDTO[]> {
    return this.get(`/orcamentos/conserto/faixa-preco`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter faixa de preço.");
      });
  }

  excluirFaixaPrecoConcerto(id: number) {
    return this.delete(`/orcamentos/conserto/faixa-preco/${id}`).catch(() => {
      throw new Error("Falha ao excluir a faixa de preço.");
    });
  }

  salvarFaixaPrecoConcerto(faixaDePrecoDTO:FaixaDePrecoDTO): Promise<any> {
    return this.post(`/orcamentos/conserto/faixa-preco`, faixaDePrecoDTO)
    .catch((error: AxiosError) => {
      const data = error.response?.data;
        if (data.status == 400) {
          throw new Error(data.detail);
        } else {
          throw new Error("Falha ao salvar faixa de preço.");
        }
    });
  }

  
  obterClientesFrota():  Promise<ClienteFrotaDTO[]> {
    return this.get(`/orcamentos/frota/clientes`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter clientes frota.");
      });
  }

}

export const orcamentoAutoApi = new OrcamentoAutoApi(
  orcamentoAutoOnlineApiConfig
);
